import { BookingReason } from '@app/domain/BookingReason'
import {
    DateComponentDescriptionPipe,
} from '@app/features/shared/pipes/date-component-description.pipe'
import { Pipe, PipeTransform } from '@angular/core'
import { ReasonScheduleRule } from '@app/domain/ReasonScheduleRule'

@Pipe({
    name: 'reasonSchedule',
})
export class ReasonSchedulePipe implements PipeTransform {

    constructor(
        private dateComponentsPipe: DateComponentDescriptionPipe
    ) { }

    transform(reason: BookingReason): string | null {
        const openRules = reason.schedule
            .filter(rule => rule.period === null || rule.period.open)

        const earliestFirst = openRules.sort((a, b) => {
            if (a.period === null && b.period === null) {
                return 0
            }
            if (a.period === null) {
                return -1
            }
            if (b.period === null) {
                return 1
            }
            const aStart = a.period.start.hours * 60 + a.period.start.minutes
            const bStart = b.period.start.hours * 60 + b.period.start.minutes
            return aStart - bStart
        })

        return earliestFirst
            .map(rule => this.composeOpenPeriodDescription(rule))
            .join('\n')
    }

    private composeOpenPeriodDescription(rule: ReasonScheduleRule): string {
        let timeRange = 'All Day'
        if (rule.period !== null) {
            timeRange = `${rule.period.start} - ${rule.period.end}`
        }
        const day = this.dateComponentsPipe.transform(rule.daysOfWeek)
        return `${timeRange} ${day}`
    }
}
